import Cookies from 'js-cookie'
import { getApiUrl } from './storage'

const domain = 'https://www.aibang360.com'

const appid = 'wx794bdb61946633eb'
const openid = 'wxcedf5e0067272523'
const redirectCode = [401, 403]

const localSmsDebug = process.env.NODE_ENV === 'development' && process.env.LOCAL_SMS_DEBUG === '1'
const apiUrl = localSmsDebug ? window.location.origin : (getApiUrl() || 'https://api.aibang360.com')
const downloadUrl = `${apiUrl}/aa/v1/admin/download/csv`
// const apiUrl = 'https://api-frp.aibang360.com'
// const apiUrl = 'https://api.v2.aibang360.com/'
// const apiUrl = 'https://api-test.aibang360.com'
// const apiUrl = 'https://api-50-3.aibang360.com'

const apiVideoUrl = localSmsDebug ? window.location.origin : 'https://api-video.aibang360.com'

// const apiVideoUrl = 'https://api-test.aibang360.com'

function getLanguage() {
  const chooseLanguage = Cookies.get('language')
  let lang = 'zh'
  if (chooseLanguage) {
    lang = chooseLanguage
  } else {
    const language = (navigator.language ||
      navigator.browserLanguage).toLowerCase()
    const locales = ['zh', 'en']
    for (const locale of locales) {
      if (language.indexOf(locale) > -1) {
        lang = locale
      }
    }
  }
  return lang
}

const language = getLanguage() === 'zh'

const countryOptions = [
  {
    key: '86',
    value: `${language ? '中国大陆' : 'China Mainland'} +86`
  },
  { key: '1', value: `${language ? '美国' : 'United States'} +1` },
  { key: '852', value: `${language ? '中国香港' : 'Hong Kong'} +852` },
  { key: '853', value: `${language ? '中国澳门' : 'Macro'} +853` },
  { key: '886', value: `${language ? '中国台湾' : 'Taiwan'} +886` },
  { key: '81', value: `${language ? '日本' : 'Japan'} +81` },
  { key: '82', value: `${language ? '韩国' : 'Korea'} +82` },
  { key: '65', value: `${language ? '新加坡' : 'Singapore'} +65` },
  { key: '60', value: `${language ? '马来西亚' : 'Malaysia'} +60` },
  { key: '84', value: `${language ? '越南' : 'Vietnam'} +84` },
  { key: '66', value: `${language ? '泰国' : 'Thailand'} +66` },
  { key: '61', value: `${language ? '澳大利亚' : 'Australia'} +61` },
  { key: '64', value: `${language ? '新西兰' : 'New Zealand'} +64` },
  { key: '7', value: `${language ? '俄罗斯' : 'Russia'} +7` },
  { key: '44', value: `${language ? '英国' : 'England'} +44` },
  { key: '33', value: `${language ? '法国' : 'Franch'} +33` },
  { key: '49', value: `${language ? '德国' : 'Germany'} +49` },
  { key: '39', value: `${language ? '意大利' : 'Italy'} +39` },
  { key: '34', value: `${language ? '西班牙' : 'Spain'} +34` },
  { key: '90', value: `${language ? '土耳其' : 'Turkey'} +90` }
]

const focus = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUzNzMyMzkzMg==&scene=126#wechat_redirect'
export default {
  domain,
  downloadUrl,
  appid,
  openid,
  focus,
  redirectCode,
  countryOptions,
  apiUrl,
  apiVideoUrl
}



// WEBPACK FOOTER //
// ./src/utils/global.js